import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Alert,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Spinner,
  Row,
  Label,
  Card,
  CardTitle,
  Popover,
  PopoverBody,
} from 'reactstrap';
import IntlMessages from '../../../../../../../../helpers/IntlMessages';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import 'react-quill/dist/quill.bubble.css';
import {
  Separator,
  Colxx,
} from '../../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Twilio_Templates,
  postAPI_GuestMessagingReservation_SendMessage,
  aPI_Contacts_Eligible,
  postAPI_ScheduledMessages,
  putAPI_ScheduledMessages,
  deleteAPI_ScheduledMessages,
} from '../../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
import countryCodes from '../../../../../../../../data/dial_code';
import moment from 'moment-timezone';

const STATUS_OPTIONS = [
  { label: 'In House', value: 'InHouse' },
  { label: 'Arrived Today', value: 'ArrivedToday' },
  { label: 'Arrived Yesterday', value: 'ArrivedYesterday' },
  { label: 'Departing Today', value: 'DepartingToday' },
  { label: 'Departing Tomorrow', value: 'DepartingTomorrow' },
  { label: 'Departed Today', value: 'DepartedToday' },
  { label: 'Departed Yesterday', value: 'DepartedYesterday' },
];
const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const PLACEHOLDER_VALUE_MAP = {
  guest_first_name: (r) => r?.firstName || '',
  guest_last_name: (r) => r?.lastName || '',
  guest_phone: (r) => r?.phone || '',
  guest_email: (r) => r?.email || '',
  room_number: (r) => r?.roomNumber || '',
  room_type: (r) => r?.roomTypeName || '',
  check_in_date: (r) => formatDate(r?.arrivalDate || ''),
  check_out_date: (r) => formatDate(r?.departureDate || ''),
};

const BULK_LABEL_MAP = {
  guest_first_name: 'First Name',
  guest_last_name: 'Last Name',
  guest_phone: 'Phone Number',
  guest_email: 'Email Address',
  room_number: 'Room Number',
  room_type: 'Room Type',

  check_in_date: 'Arrival Date',
  check_out_date: 'Departure Date',
};
const FIVE_MINUTE_OPTIONS = [
  '00',
  '05',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
];
const HOUR_OPTIONS_24 = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0')
);

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;      
      }
 
      .ql-container{
        border: 1px solid #ccc !important;
        border-radius: 0px!important;  
        background:white;      
      }
     
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const WhatsApptab = ({
  propertyId,
  preFillPhoneNumber,
  showStatusFilter = false,
  showPhoneNumber = false,
  reservationId,
  source,
  onStatusChange,
  totalCount,
  loadingCount,
  reservationData,
  showEligibleCount = false,
  eligibleCount = 0,
  eligibleCountLabel = 'Eligible Members',
  disabledSubmitMessage = '',
  recipientId,
}) => {
  const { userName, timeZone } = useSelector(({ settings }) => ({
    userName: settings.userName,
    timeZone: settings.timeZone,
  }));

  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
  const [isScheduleStatusMessage, setIsScheduleStatusMessage] = useState(false);
  const [whatsAppData, setwhatsAppData] = useState({
    templateId: '',
    to: '',
    countryCode: '+64',
    rawNumber: preFillPhoneNumber || '',
    text: '',
  });
  const MARKETING_CONSENT_OPTIONS = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  const [marketingConsent, setMarketingConsent] = useState(null);
  const [memberEligibleCount, setMemberEligibleCount] = useState(0);
  const [selectedTag, setSelectedTag] = useState(null);
  const [eligibleLoading, setEligibleLoading] = useState(false);
  const [tagList, setTagList] = useState([]);
  const showMarketingConsent = source === 'MembersBulk';
  const showTagList = source === 'MembersBulk';
  const fetchEligibleCount = async (consent, tag) => {
    setEligibleLoading(true);
    const res = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts_Eligible}?groupId=${getGroupID()}&propertyId=${propertyId}&marketingConsent=${consent}&tag=${tag}`,
    });

    setMemberEligibleCount(res.data?.eligibleCount || 0);
    setTagList(
      (res.data?.tags || []).map((x) => ({
        label: x,
        value: x,
      }))
    );
    setEligibleLoading(false);
  };
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduledDateTime, setScheduledDateTime] = useState('');
  const [scheduledMessageId, setScheduledMessageId] = useState(null);
  const [scheduledProcessingStatus, setScheduledProcessingStatus] = useState('');
  const [scheduledCommunicationScope, setScheduledCommunicationScope] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const resetSchedule = () => {
    setIsScheduled(false);
    setScheduledDateTime('');
    setScheduledMessageId(null);
    setScheduledProcessingStatus('');
    setScheduledCommunicationScope('');
    setShowDeleteConfirm(false);
  };
  const isMembershipSource = source === 'Members' || source === 'MembersBulk';
  const isBulkSource = source === 'Bulk' || source === 'MembersBulk';
  const normalizedScheduledStatus = String(scheduledProcessingStatus || '')
    .trim()
    .toLowerCase();
  const displayScheduledStatus = {
    pending: 'Scheduled',
    processing: 'Processing',
    processed: 'Completed',
    completed: 'Completed',
    failed: 'Failed',
  }[normalizedScheduledStatus] || '';
  const bulkScheduleRecipientNotice =
    source === 'MembersBulk'
      ? 'Recipient count may change before sending. The final number of members will be calculated at send time based on the latest Marketing Consent and Member Tag criteria.'
      : source === 'Bulk'
        ? 'Recipient count may change before sending. The final number of guests will be calculated at send time based on the latest reservation status and valid, unique mobile numbers.'
        : '';
  const isIndividualSource = source === 'Manually' || source === 'Members';
  const resolvedMembershipId = recipientId || null;
  const groupId = getGroupID();
  const scheduleChannelType = 'Whatsapp';
  const scheduleTimeZone = timeZone || 'UTC';
  const hasExplicitTimezoneInfo = (value) => {
    if (!value || typeof value !== 'string') return false;

    return /(?:Z|[+-]\d{2}:\d{2}|[+-]\d{4})$/i.test(value.trim());
  };
  const parseScheduledUtcValue = (value) => {
    if (!value) return null;

    const dateTimeFormats = [
      moment.ISO_8601,
      'YYYY-MM-DDTHH:mm:ss[Z]',
      'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
      'YYYY-MM-DDTHH:mm:ssZ',
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DDTHH:mm',
      'DD-MM-YYYY HH:mm:ss',
    ];

    const hasTimezoneInfo = hasExplicitTimezoneInfo(value);

    if (hasTimezoneInfo) {
      let parsedWithZone = moment.parseZone(value, dateTimeFormats, true);
      if (!parsedWithZone.isValid()) {
        parsedWithZone = moment.parseZone(value);
      }

      return parsedWithZone.isValid()
        ? parsedWithZone.tz(scheduleTimeZone)
        : null;
    }

    // If timezone info is absent, treat value as wall-clock time for selected timezone.
    // This avoids double conversion when backend already applies the requested timeZone.
    let parsedLocal = moment.tz(value, dateTimeFormats, true, scheduleTimeZone);
    if (!parsedLocal.isValid()) {
      parsedLocal = moment.tz(value, scheduleTimeZone);
    }

    return parsedLocal.isValid() ? parsedLocal : null;
  };
  const normalizeScheduledDateTimeValue = (value) => {
    if (!value) return '';

    const parsedValue = parseScheduledUtcValue(value);
    if (!parsedValue) return '';

    return parsedValue.format('YYYY-MM-DDTHH:mm');
  };
  const getScheduledItemId = (item) =>
    item?.id || item?.scheduledMessageId || item?.scheduledmessageId || null;
  const isWhatsAppChannelMatch = (item) => {
    if (!item || item.channelType === null || item.channelType === undefined) {
      return true;
    }

    const channelType = String(item.channelType).toLowerCase();
    return (
      channelType === 'whatsapp' ||
      channelType === '2' ||
      channelType.includes('whatsapp')
    );
  };
  const getScheduledItemDate = (item, responseData) => {
    const scheduledUtcValue =
      item?.scheduledUtc ||
      item?.ScheduledUtc ||
      responseData?.scheduledUtc ||
      responseData?.ScheduledUtc;

    if (scheduledUtcValue) {
      const convertedValue = normalizeScheduledDateTimeValue(scheduledUtcValue);
      return convertedValue;
    }

    const localDateValue =
      item?.scheduledDateTime ||
      item?.ScheduledDateTime ||
      responseData?.scheduledDateTime ||
      responseData?.ScheduledDateTime;

    if (!localDateValue) {
      return '';
    }

    const localMoment = moment.tz(
      localDateValue,
      [
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DDTHH:mm',
        moment.ISO_8601,
      ],
      true,
      scheduleTimeZone
    );

    if (!localMoment.isValid()) {
      return '';
    }

    return localMoment.format('YYYY-MM-DDTHH:mm');
  };
  const getBackendMessage = (response, fallback) =>
    typeof response === 'string'
      ? response
      : response?.statusMessage || response?.message || fallback;
  const getResponseText = (response) => {
    if (!response) return '';
    if (typeof response === 'string') return response;

    const messages = Array.isArray(response?.Messages)
      ? response.Messages.filter(Boolean).join(', ')
      : '';

    return [
      response?.statusMessage,
      response?.message,
      response?.error,
      response?.errorMessage,
      messages,
    ]
      .filter(Boolean)
      .join(' ');
  };
  const isFailedResponse = (response) => {
    if (!response) return false;

    if (Number(response?.HttpStatusCode) >= 400) return true;
    if (String(response?.Type || '').toLowerCase() === 'internal server') {
      return true;
    }

    if (
      response?.twilioerrorcode ||
      response?.twilioErrorCode ||
      response?.TwilioErrorCode ||
      response?.twilioErrorMessage ||
      response?.TwilioErrorMessage
    ) {
      return true;
    }

    const explicitStatus = [
      response?.status,
      response?.Status,
      response?.result,
      response?.Result,
    ].find((status) => typeof status === 'string');

    if (explicitStatus) {
      const normalizedStatus = explicitStatus.toLowerCase();
      if (
        normalizedStatus === 'failed' ||
        normalizedStatus === 'failure' ||
        normalizedStatus === 'error'
      ) {
        return true;
      }
    }

    const text = getResponseText(response).toLowerCase();
    if (!text) return false;

    return (
      text.includes('twilioerrorcode') ||
      text.startsWith('failed') ||
      text.includes('failed -') ||
      text.includes('failed to') ||
      text.includes('invalid parameter')
    );
  };
  const getBackendError = (error, fallback) =>
    error?.message ||
    (typeof error?.response?.data === 'string'
      ? error.response.data
      : error?.response?.data?.Messages?.join(', ') ||
      error?.response?.data?.statusMessage ||
      error?.response?.data?.message ||
      fallback);
  const isNoScheduledMessageResponse = (error, requestContext = {}) => {
    const httpStatus = error?.response?.status;
    if (httpStatus === 404) {
      return true;
    }

    const responseData = error?.response?.data;
    const nestedData = responseData?.data;
    const nestedError = responseData?.error;
    const responseMessages = [
      responseData?.Messages,
      nestedData?.Messages,
      nestedError?.Messages,
      nestedData?.errors,
      responseData?.errors,
    ]
      .flat()
      .filter(Boolean)
      .map((m) => (typeof m === 'string' ? m : JSON.stringify(m)))
      .join(' ');
    const responseText = [
      error?.message,
      error?.response?.statusText,
      typeof responseData === 'string' ? responseData : '',
      responseData?.message,
      responseData?.statusMessage,
      responseData?.error,
      responseData?.errorDescription,
      responseData?.errorMessage,
      responseData?.title,
      responseData?.detail,
      responseData?.exceptionMessage,
      nestedData?.message,
      nestedData?.statusMessage,
      nestedData?.error,
      nestedData?.title,
      nestedData?.detail,
      nestedError?.message,
      nestedError?.statusMessage,
      nestedError?.error,
      responseMessages,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    const nestedStatusCode =
      Number(responseData?.statusCode) ||
      Number(nestedData?.statusCode) ||
      Number(nestedError?.statusCode) ||
      null;

    if (nestedStatusCode === 404) {
      return true;
    }

    if (!responseText) {
      const isScheduledLookup = String(requestContext?.url || '').includes(
        '/scheduled-messages'
      );
      return httpStatus === 502 && isScheduledLookup;
    }

    const hasNoScheduleText =
      responseText.includes('no schedule') ||
      responseText.includes('no scheduled message') ||
      responseText.includes('schedule not found') ||
      responseText.includes('scheduled message not found') ||
      responseText.includes('no record found') ||
      responseText.includes('resource not found') ||
      responseText.includes('not found');

    if (!hasNoScheduleText) {
      const isScheduledLookup = String(requestContext?.url || '').includes(
        '/scheduled-messages'
      );
      const hasHardFailureText =
        responseText.includes('timeout') ||
        responseText.includes('timed out') ||
        responseText.includes('network error') ||
        responseText.includes('connection refused') ||
        responseText.includes('internal server error') ||
        responseText.includes('unauthorized') ||
        responseText.includes('forbidden');

      if (httpStatus === 502 && isScheduledLookup && !hasHardFailureText) {
        return true;
      }

      return false;
    }

    return httpStatus !== 401 && httpStatus !== 403;
  };
  const getScheduledItemTemplateId = (item) =>
    item?.templateId || item?.TemplateId || item?.messageTemplateId || null;
  const getScheduledItemCommunicationType = (item) =>
    item?.communicationType || item?.CommunicationType || null;
  const getScheduledItemReservationId = (item) =>
    item?.reservationId || item?.ReservationId || null;
  const getScheduledItemMembershipId = (item) =>
    item?.membershipId || item?.MembershipId || item?.recipientId || item?.RecipientId || null;
  const getScheduledItemGroupId = (item) =>
    item?.groupId || item?.GroupId || null;
  const getScheduledItemPropertyId = (item) =>
    item?.propertyId || item?.PropertyId || null;
  const getScheduledItemReservationStatus = (item) =>
    item?.reservationStatus || item?.ReservationStatus || null;
  const getScheduledItemMarketingConsent = (item) =>
    item?.marketingConsent || item?.MarketingConsent || null;
  const getScheduledItemMemberTag = (item) =>
    item?.memberTag || item?.MemberTag || null;
  const getScheduledItemProcessingStatus = (item) =>
    item?.processingStatus || item?.ProcessingStatus || '';
  const getScheduledItemCommunicationScope = (item) =>
    item?.communicationScope || item?.CommunicationScope || '';
  const normalizeComparableValue = (value) =>
    value === undefined || value === null || value === '' ? null : String(value);
  const normalizeCommunicationScope = (value) => {
    const normalized = normalizeComparableValue(value);
    if (normalized === null) return null;

    const lower = normalized.toLowerCase();
    if (lower.includes('bulk')) return 'bulk';
    if (lower.includes('individual')) return 'individual';

    return lower;
  };
  const normalizeCommunicationType = (value) => {
    const normalized = normalizeComparableValue(value);
    if (normalized === null) return null;

    const lower = normalized.toLowerCase();
    if (lower === '1' || lower.includes('guest')) return '1';
    if (lower === '2' || lower.includes('member')) return '2';

    return normalized;
  };
  const normalizeScheduledResponseItems = (responseOrPayload) => {
    if (!responseOrPayload) return [];

    if (Array.isArray(responseOrPayload)) {
      return responseOrPayload.filter(Boolean);
    }

    if (Array.isArray(responseOrPayload?.data)) {
      return responseOrPayload.data.filter(Boolean);
    }

    if (Array.isArray(responseOrPayload?.items)) {
      return responseOrPayload.items.filter(Boolean);
    }

    if (responseOrPayload?.data && typeof responseOrPayload.data === 'object') {
      return [responseOrPayload.data];
    }

    if (typeof responseOrPayload === 'object') {
      return [responseOrPayload];
    }

    return [];
  };
  const getScheduleContext = (selectedTemplateId) => {
    const communicationType = isMembershipSource ? 2 : 1;

    return {
      templateId: selectedTemplateId || null,
      channelType: scheduleChannelType,
      communicationType,
      isBulk: isBulkSource,
      isIndividual: isIndividualSource,
      isMembership: isMembershipSource,
      reservationId:
        !isBulkSource && !isMembershipSource ? reservationId || null : null,
      membershipId:
        !isBulkSource && isMembershipSource ? resolvedMembershipId || null : null,
      groupId: groupId || null,
      propertyId: propertyId || null,
      reservationStatus: source === 'Bulk' ? selectedStatus?.value || null : null,
      marketingConsent:
        source === 'MembersBulk' ? marketingConsent?.value || '' : null,
      memberTag: source === 'MembersBulk' ? selectedTag?.value || '' : null,
      communicationScope: isBulkSource ? 'Bulk' : 'Individual',
      timeZone: timeZone || null,
    };
  };
  const buildScheduledGetUrl = (scheduleContext) => {
    if (!scheduleContext?.templateId) {
      return null;
    }

    const params = new URLSearchParams();
    params.set('templateId', scheduleContext.templateId);
    params.set('channelType', scheduleContext.channelType);
    params.set('communicationType', String(scheduleContext.communicationType));

    if (scheduleContext.timeZone) {
      params.set('timeZone', scheduleContext.timeZone);
    }

    if (scheduleContext.isBulk) {
      if (!scheduleContext.groupId || !scheduleContext.propertyId) {
        return null;
      }

      params.set('groupId', scheduleContext.groupId);
      params.set('propertyId', scheduleContext.propertyId);

      if (source === 'Bulk') {
        if (!scheduleContext.reservationStatus) {
          return null;
        }
        params.set('reservationStatus', scheduleContext.reservationStatus);
      }

      if (source === 'MembersBulk') {
        params.set('marketingConsent', scheduleContext.marketingConsent || '');
        params.set('memberTag', scheduleContext.memberTag || '');
      }

      return `${postAPI_ScheduledMessages}?${params.toString()}`;
    }

    if (scheduleContext.isMembership) {
      if (!scheduleContext.membershipId) {
        return null;
      }

      params.set('membershipId', scheduleContext.membershipId);
      return `${postAPI_ScheduledMessages}?${params.toString()}`;
    }

    if (!scheduleContext.reservationId) {
      return null;
    }

    params.set('reservationId', scheduleContext.reservationId);
    return `${postAPI_ScheduledMessages}?${params.toString()}`;
  };
  const isScheduledItemMatchingContext = (item, scheduleContext) => {
    if (!item || !scheduleContext) {
      return false;
    }

    const itemCommunicationType = getScheduledItemCommunicationType(item);
    if (
      itemCommunicationType !== null &&
      normalizeCommunicationType(itemCommunicationType) !==
      normalizeCommunicationType(scheduleContext.communicationType)
    ) {
      return false;
    }

    const itemReservationId = getScheduledItemReservationId(item);
    const itemMembershipId = getScheduledItemMembershipId(item);
    const itemGroupId = getScheduledItemGroupId(item);
    const itemPropertyId = getScheduledItemPropertyId(item);
    const itemReservationStatus = getScheduledItemReservationStatus(item);
    const itemMarketingConsent = getScheduledItemMarketingConsent(item);
    const itemMemberTag = getScheduledItemMemberTag(item);
    const itemCommunicationScope = getScheduledItemCommunicationScope(item);

    if (normalizeCommunicationScope(itemCommunicationScope) !== null) {
      if (
        normalizeCommunicationScope(itemCommunicationScope) !==
        normalizeCommunicationScope(scheduleContext.communicationScope)
      ) {
        return false;
      }
    }

    if (scheduleContext.isBulk) {
      if (normalizeComparableValue(itemReservationId) !== null) {
        return false;
      }

      if (normalizeComparableValue(itemMembershipId) !== null) {
        return false;
      }

      if (
        scheduleContext.groupId &&
        normalizeComparableValue(itemGroupId) !==
        normalizeComparableValue(scheduleContext.groupId)
      ) {
        return false;
      }

      if (
        scheduleContext.propertyId &&
        normalizeComparableValue(itemPropertyId) !==
        normalizeComparableValue(scheduleContext.propertyId)
      ) {
        return false;
      }

      if (source === 'Bulk') {
        if (
          normalizeComparableValue(itemReservationStatus) !==
          normalizeComparableValue(scheduleContext.reservationStatus)
        ) {
          return false;
        }
      }

      if (source === 'MembersBulk') {
        if (
          normalizeComparableValue(itemMarketingConsent) !==
          normalizeComparableValue(scheduleContext.marketingConsent)
        ) {
          return false;
        }

        if (
          normalizeComparableValue(itemMemberTag) !==
          normalizeComparableValue(scheduleContext.memberTag)
        ) {
          return false;
        }
      }

      return true;
    }

    if (scheduleContext.isMembership) {
      if (
        normalizeComparableValue(itemMembershipId) !==
        normalizeComparableValue(scheduleContext.membershipId)
      ) {
        return false;
      }

      if (normalizeComparableValue(itemReservationId) !== null) {
        return false;
      }

      return true;
    }

    if (
      normalizeComparableValue(itemReservationId) !==
      normalizeComparableValue(scheduleContext.reservationId)
    ) {
      return false;
    }

    if (normalizeComparableValue(itemMembershipId) !== null) {
      return false;
    }

    return true;
  };
  const findScheduledItem = (
    payload,
    selectedTemplateId,
    strictTemplateMatch = false,
    scheduleContext = null
  ) => {
    const items = normalizeScheduledResponseItems(payload);
    if (!items.length) return null;

    const channelItems = items.filter((item) => {
      if (!item || !isWhatsAppChannelMatch(item)) {
        return false;
      }

      if (scheduleContext) {
        return isScheduledItemMatchingContext(item, scheduleContext);
      }

      return true;
    });

    if (!channelItems.length) {
      return null;
    }

    if (
      selectedTemplateId !== undefined &&
      selectedTemplateId !== null &&
      selectedTemplateId !== ''
    ) {
      const matchedByTemplate = channelItems.find(
        (item) => String(getScheduledItemTemplateId(item)) === String(selectedTemplateId)
      );

      if (matchedByTemplate) {
        return matchedByTemplate;
      }

      if (strictTemplateMatch) {
        return null;
      }
    }

    return channelItems[0] || null;
  };
  const buildScheduledPayload = () => {
    const communicationType = isMembershipSource ? 2 : 1;
    const reservationStatus = source === 'Bulk' ? selectedStatus?.value || null : null;
    const scheduleMoment = moment.tz(
      scheduledDateTime,
      'YYYY-MM-DDTHH:mm',
      true,
      scheduleTimeZone
    );
    const scheduledUtc = scheduleMoment.isValid()
      ? scheduleMoment.utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
      : null;

    return {
      communicationType,
      reservationId:
        communicationType === 1 && source !== 'Bulk' ? reservationId || null : null,
      membershipId:
        communicationType === 2 && source === 'Members'
          ? resolvedMembershipId
          : null,
      reservationStatus,
      marketingConsent: showMarketingConsent
        ? marketingConsent?.value || null
        : null,
      memberTag: showTagList ? selectedTag?.value || null : null,
      templateId: whatsAppData?.templateId || null,
      channelType: 'Whatsapp',
      scheduledDateTime,
      scheduledUtc,
      ScheduledUtc: scheduledUtc,
      timeZone,
      groupId,
      propertyId,
      createdBy: userName,
    };
  };
  const validateSchedule = () => {
    if (!isScheduled) {
      return true;
    }

    if (!scheduledDateTime) {
      NotificationManager.error(
        '',
        'Please select scheduled date and time.',
        3000
      );
      return false;
    }

    const selectedDate = moment.tz(
      scheduledDateTime,
      'YYYY-MM-DDTHH:mm',
      true,
      scheduleTimeZone
    );
    const now = moment.tz(scheduleTimeZone);

    if (!selectedDate.isValid()) {
      NotificationManager.error(
        '',
        'Please select a valid scheduled date and time.',
        3000
      );
      return false;
    }

    if (!selectedDate.isAfter(now)) {
      NotificationManager.error(
        '',
        'Scheduled date and time must be in the future.',
        3000
      );
      return false;
    }

    if (selectedDate.minutes() % 5 !== 0) {
      NotificationManager.error(
        '',
        'Please select time in 5-minute intervals.',
        3000
      );
      return false;
    }

    return true;
  };
  const getMinScheduleMoment = () => {
    const minMoment = moment.tz(scheduleTimeZone);
    minMoment.seconds(0);
    minMoment.milliseconds(0);

    const remainder = minMoment.minutes() % 5;
    if (remainder !== 0) {
      minMoment.add(5 - remainder, 'minutes');
    }

    return minMoment;
  };
  const getMinScheduleDateTime = () => {
    return getMinScheduleMoment().format('YYYY-MM-DDTHH:mm');
  };
  const getScheduleParts = () => {
    const parsed = moment.tz(
      scheduledDateTime,
      'YYYY-MM-DDTHH:mm',
      true,
      scheduleTimeZone
    );
    const selected = parsed.isValid() ? parsed : getMinScheduleMoment();

    const hour = selected.format('HH');
    const minute = selected.format('mm');
    const hourValue = hour;
    const minuteValue = minute;

    return {
      date: selected.format('YYYY-MM-DD'),
      hour: hourValue,
      minute: minuteValue,
    };
  };
  const updateScheduledDateTimeFromParts = (nextParts) => {
    const safeDate = nextParts?.date;
    const safeHour = nextParts?.hour;
    const safeMinute = nextParts?.minute;

    if (!safeDate || safeHour === undefined || safeMinute === undefined) {
      return;
    }

    let selected = moment.tz(
      `${safeDate}T${safeHour}:${safeMinute}`,
      'YYYY-MM-DDTHH:mm',
      true,
      scheduleTimeZone
    );

    if (!selected.isValid()) {
      return;
    }

    setScheduledDateTime(selected.format('YYYY-MM-DDTHH:mm'));
  };
  const loadScheduledMessage = async (selectedTemplateId) => {
    if (!selectedTemplateId) {
      resetSchedule();
      return;
    }

    const scheduleContext = getScheduleContext(selectedTemplateId);
    const url = buildScheduledGetUrl(scheduleContext);
    if (!url) {
      resetSchedule();
      return;
    }

    resetSchedule();

    try {
      const res = await AxiosAPI({
        method: 'get',
        url,
      });

      const item = findScheduledItem(res, selectedTemplateId, true, scheduleContext);
      if (!item) {
        resetSchedule();
        return;
      }

      const existingId = getScheduledItemId(item);
      if (!existingId) {
        resetSchedule();
        return;
      }

      setScheduledMessageId(existingId);
      setIsScheduled(true);
      setScheduledProcessingStatus(getScheduledItemProcessingStatus(item));
      setScheduledCommunicationScope(getScheduledItemCommunicationScope(item));
      if (isIndividualSource) {
        setIsScheduleStatusMessage(true);
      }
      const convertedValue = getScheduledItemDate(item, res?.data);
      setScheduledDateTime(convertedValue);
    } catch (error) {
      if (isNoScheduledMessageResponse(error, { url })) {
        resetSchedule();
        setStatusMessage({ text: '', type: '' });
        setIsScheduleStatusMessage(false);
        return;
      }

      setStatusMessage({
        text: getBackendError(
          error,
          'Failed to fetch scheduled WhatsApp message.'
        ),
        type: 'error',
      });
      setIsScheduleStatusMessage(true);
    }
  };
  const scheduleWhatsAppMessage = async () => {
    if (!canSend) {
      NotificationManager.error(
        '',
        'No mobile number available for this contact.',
        3000
      );
      return;
    }

    if (source === 'Bulk' && !selectedStatus) {
      NotificationManager.error(
        '',
        'Please select a status before scheduling message.',
        3000
      );
      return;
    }

    if (isMembershipSource && source === 'Members' && !resolvedMembershipId) {
      NotificationManager.error('', 'Membership ID is required.', 3000);
      return;
    }

    if (!validateSchedule()) {
      return;
    }

    const payload = buildScheduledPayload();
    const isUpdate = !!scheduledMessageId;
    const data = isUpdate
      ? {
        ...payload,
        id: scheduledMessageId,
        scheduledMessageId,
      }
      : payload;

    try {
      setScheduleLoading(true);

      const res = await AxiosAPI({
        method: isUpdate ? 'put' : 'post',
        url: isUpdate ? putAPI_ScheduledMessages : postAPI_ScheduledMessages,
        data,
      });

      if (isFailedResponse(res?.data)) {
        throw new Error(
          getResponseText(res?.data) ||
          `Failed to ${isUpdate ? 'update' : 'create'} scheduled WhatsApp message.`
        );
      }

      const scheduledItem = findScheduledItem(res?.data, whatsAppData?.templateId) || res?.data;
      const existingId = getScheduledItemId(scheduledItem) || scheduledMessageId;
      if (existingId) {
        setScheduledMessageId(existingId);
      }

      const updatedDate = getScheduledItemDate(scheduledItem);
      if (updatedDate) {
        setScheduledDateTime(updatedDate);
      }

      setScheduledProcessingStatus(getScheduledItemProcessingStatus(scheduledItem));
      setScheduledCommunicationScope(
        getScheduledItemCommunicationScope(scheduledItem)
      );

      const scheduledSuccessText = isUpdate
        ? 'Scheduled WhatsApp message updated successfully.'
        : 'Scheduled WhatsApp message created successfully.';

      const backendStatus = getBackendMessage(res?.data, scheduledSuccessText);

      setIsScheduled(true);
      setIsScheduleStatusMessage(true);
      setStatusMessage({
        text: backendStatus.toLowerCase().includes('scheduled')
          ? backendStatus
          : scheduledSuccessText,
        type: 'success',
      });
    } catch (error) {
      setIsScheduleStatusMessage(true);
      setStatusMessage({
        text: getBackendError(
          error,
          `Failed to ${isUpdate ? 'update' : 'create'} scheduled WhatsApp message.`
        ),
        type: 'error',
      });
    } finally {
      setScheduleLoading(false);
    }
  };
  const handleScheduleToggle = async () => {
    if (!isScheduled) {
      if (!scheduledDateTime) {
        setScheduledDateTime(getMinScheduleDateTime());
      }
      setIsScheduled(true);
      return;
    }

    if (!scheduledMessageId) {
      resetSchedule();
      return;
    }

    setShowDeleteConfirm(true);
  };

  const handleConfirmScheduleDelete = async () => {
    if (!scheduledMessageId) {
      resetSchedule();
      return;
    }

    try {
      setScheduleLoading(true);
      await AxiosAPI({
        method: 'delete',
        url: `${deleteAPI_ScheduledMessages}/${scheduledMessageId}`,
      });

      resetSchedule();
      setIsScheduleStatusMessage(true);
      setStatusMessage({
        text: 'Scheduled WhatsApp message deleted successfully.',
        type: 'error',
      });
    } catch (error) {
      setIsScheduled(true);
      setIsScheduleStatusMessage(true);
      setStatusMessage({
        text: getBackendError(
          error,
          'Failed to delete scheduled WhatsApp message.'
        ),
        type: 'error',
      });
    } finally {
      setShowDeleteConfirm(false);
      setScheduleLoading(false);
    }
  };

  useEffect(() => {
    loadScheduledMessage(whatsAppData?.templateId);
  }, [
    source,
    reservationId,
    resolvedMembershipId,
    selectedStatus?.value,
    marketingConsent?.value,
    selectedTag?.value,
    whatsAppData?.templateId,
    timeZone,
  ]);

  useEffect(() => {
    if (statusMessage.text) {
      const timer = setTimeout(() => {
        setStatusMessage({ text: '', type: '' });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  useEffect(() => {
    if (!showMarketingConsent) {
      setMarketingConsent(null);
      setMemberEligibleCount(0);
    }
  }, [showMarketingConsent]);

  useEffect(() => {
    if (showTagList) {
      fetchEligibleCount('', '');
    }
  }, [showTagList]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
    }).then((res) => {
      setTemplateList(res.data);
      if (preFillPhoneNumber !== undefined && preFillPhoneNumber != null) {
        let raw = preFillPhoneNumber || '';
        let dialCode = '+64';
        countryCodes.map((m) => {
          if (raw.startsWith(m.dial_code)) {
            raw = raw.replace(m.dial_code, '');
            dialCode = m.dial_code;
          }
        });
        setwhatsAppData((prev) => ({
          ...prev,
          rawNumber: raw,
          countryCode: dialCode,
          to: `${dialCode}${raw}`,
        }));
      }
    });
  }, [propertyId, preFillPhoneNumber]);

  const handleTemplate = (e) => {
    const selectedTemplateId = e.target.value;
    resetSchedule();
    setIsScheduleStatusMessage(false);

    if (!selectedTemplateId) {
      setwhatsAppData((prev) => ({
        ...prev,
        templateId: '',
        text: '',
        placeholders: [],
      }));
      return;
    }

    const selectedTemplate = templateList.find(
      (t) => String(t.templateId) === String(selectedTemplateId)
    );
    if (!selectedTemplate) {
      setwhatsAppData((prev) => ({
        ...prev,
        templateId: selectedTemplateId,
        text: '',
        placeholders: [],
      }));
      return;
    }
    const text = selectedTemplate.templateBody || '';

    const placeholders = (selectedTemplate.placeholders || []).map((ph) => {
      const placeholderKey = `{{${ph.name}}}`;

      const value =
        source === 'Manually' || source === 'Members'
          ? PLACEHOLDER_VALUE_MAP[ph.value]?.(reservationData) || ''
          : '';

      return {
        key: placeholderKey,
        sourceKey: ph.value,
        label:
          BULK_LABEL_MAP[ph.value] ||
          ph.value.replaceAll('_', ' ').toUpperCase(),
        value,
      };
    });

    setwhatsAppData((prev) => ({
      ...prev,
      templateId: selectedTemplate.templateId,
      text,
      placeholders,
    }));
  };

  const handlePlaceHolders = (value, index) => {
    let placeholders = [...whatsAppData.placeholders];
    placeholders[index].value = value;
    setwhatsAppData({ ...whatsAppData, placeholders: placeholders });
  };

  const mobileNumber = showPhoneNumber ? whatsAppData?.rawNumber || '' : '';
  const canSend =
    !showPhoneNumber ||
    (mobileNumber && mobileNumber !== 'null' && mobileNumber.trim().length > 0);

  const sendWhatsAppMessage = async () => {
    if (!canSend) {
      NotificationManager.error(
        '',
        'No mobile number available for this contact.',
        3000
      );
      return;
    }
    // if (
    //   !whatsAppData.placeholders ||
    //   !Array.isArray(whatsAppData.placeholders) ||
    //   whatsAppData.placeholders.length === 0
    // ) {
    //   NotificationManager.error(
    //     '',
    //     'No placeholders found for selected template.',
    //     3000
    //   );
    //   return;
    // }
    let templateData = {};
    const placeholders = Array.isArray(whatsAppData.placeholders)
      ? [...whatsAppData.placeholders]
      : [];
    const isBulkMode = source === 'Bulk' || source === 'MembersBulk';

    if (isBulkMode || placeholders.every((p) => p.sourceKey)) {
      placeholders.forEach((m) => {
        const key = m?.key?.replaceAll('{', '').replaceAll('}', '');
        templateData[key] = m?.sourceKey;
      });

      let payload = {
        groupId: getGroupID(),
        propertyId,
        channel: 'Whatsapp',
        templateId: whatsAppData.templateId,
        message: whatsAppData.text,
        placeholderValues: templateData,
        CreatedBy: userName,
      };

      if (source === 'Manually') {
        payload = {
          ...payload,
          reservationId,
          MobileNumber: whatsAppData.to,
          StatusFilter: 'Individual',
        };
      }
      if (source === 'Members') {
        payload = {
          ...payload,
          sourceType: 'Members',
          recipientId: recipientId,
          MobileNumber: whatsAppData.to,
          StatusFilter: 'Individual',
        };
      }
      if (source === 'MembersBulk') {
        payload = {
          ...payload,
          sourceType: 'MembersBulk',
          StatusFilter: 'InHouse',
          marketingConsent: marketingConsent?.value || '',
          tag: selectedTag?.value || '',
        };
      }
      if (source === 'Bulk') {
        if (!selectedStatus) {
          NotificationManager.error(
            '',
            'Please select a status before sending message.',
            3000
          );
          return;
        }
        payload = {
          ...payload,
          timeZone,
          StatusFilter: selectedStatus.value,
        };
      }

      try {
        setLoading(true);

        const res = await AxiosAPI({
          method: 'post',
          url: postAPI_GuestMessagingReservation_SendMessage,
          data: payload,
        });
        if (isFailedResponse(res?.data)) {
          throw new Error(
            getResponseText(res?.data) || 'Failed to send WhatsApp message.'
          );
        }

        const backendMsg =
          typeof res?.data === 'string'
            ? res.data
            : res?.data?.statusMessage || res?.data?.message || 'Message sent';
        const isSameMessageRecentlySent =
          String(backendMsg || '').trim().toLowerCase() ===
          'same message has been sent recently.';

        if (source === 'Manually') {
          setStatusMessage({
            text: backendMsg,
            type: isSameMessageRecentlySent ? 'error' : 'success',
          });
          setIsScheduleStatusMessage(false);
        } else {
          setStatusMessage({
            text: backendMsg,
            type:
              source !== 'Bulk' &&
                source !== 'MembersBulk' &&
                isSameMessageRecentlySent
                ? 'error'
                : 'success',
          });
          setIsScheduleStatusMessage(false);
        }
      } catch (error) {
        console.error(error);

        const backendError =
          error?.message ||
          (typeof error?.response?.data === 'string'
            ? error.response.data
            : error?.response?.data?.statusMessage ||
            error?.response?.data?.message ||
            'Failed to send WhatsApp message.');

        if (source === 'Manually') {
          setStatusMessage({
            text: backendError,
            type: 'error',
          });
          setIsScheduleStatusMessage(false);
        } else {
          setStatusMessage({
            text: 'Message Failed',
            type: 'error',
          });
          setIsScheduleStatusMessage(false);
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const isUSNumber = whatsAppData?.countryCode === '+1';

  const renderBulkStatus = (msg) => {
    if (!msg) return null;

    // Only format when queued info exists
    if (!msg.toLowerCase().includes('queued')) {
      return msg;
    }

    // Split on both "|" and "," safely
    const parts = msg
      .split(/[\|,]/)
      .map((p) => p.trim())
      .filter((p) => p !== '');

    const formatPart = (part, color) => {
      if (!part.includes(':')) return part;

      const [label, value] = part.split(':');

      const cleanLabel =
        label.trim().charAt(0).toUpperCase() +
        label.trim().slice(1).toLowerCase();

      const cleanValue = value?.trim();

      return (
        <span style={{ color, fontWeight: 600 }}>
          {cleanLabel}
          {cleanValue ? `: ${cleanValue}` : ''}
        </span>
      );
    };

    const header = parts[0]; // Bulk messages processed
    const queuedPart = formatPart(parts[1], 'green');
    const failedPart = formatPart(parts[2], 'red');
    const duplicatePart = formatPart(parts[3], 'orange');
    return (
      <span>
        {header} {queuedPart && <>| {queuedPart} </>}
        {failedPart && <>| {failedPart}</>}
        {duplicatePart && <> | {duplicatePart}</>}
      </span>
    );
  };

  const renderManualStatus = (msg, type) => {
    if (!msg) return null;

    const normalized = msg.trim().toLowerCase();

    const formatted = normalized.charAt(0).toUpperCase() + normalized.slice(1);

    const isSuccess = type === 'success';

    return (
      <span
        style={{
          color: isSuccess ? 'green' : 'red',
          fontWeight: 600,
        }}
      >
        {formatted}
      </span>
    );
  };
  return (
    <Fragment>
      <Card className=" mt-2 " style={{ boxShadow: 'none' }}>
        <CardTitle className="ml-3">
          <IntlMessages id="content.sendwhatsapp" />{' '}
        </CardTitle>

        <style>{styles}</style>
        <Row className="ml-2 mr-2">
          {showStatusFilter && source === 'Bulk' && (
            <Colxx md="12" className="mb-2">
              <Label>Select status</Label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={STATUS_OPTIONS}
                placeholder="Select status"
                value={selectedStatus}
                onChange={(val) => {
                  setSelectedStatus(val);
                  if (val && onStatusChange) {
                    onStatusChange(val.value);
                  }
                }}
                isClearable
              />

              {source === 'Bulk' && selectedStatus && (
                <div className="mt-1" style={{ fontSize: '13px' }}>
                  {loadingCount ? (
                    'Fetching guest count...'
                  ) : (
                    <b>
                      Message will be sent to {totalCount} guests with valid, unique mobile numbers.
                    </b>
                  )}
                </div>
              )}
            </Colxx>
          )}

          {showMarketingConsent && showTagList && !eligibleLoading && (
            <Colxx md="12" className="mb-2">
              <div className="mt-1" style={{ fontSize: '13px' }}>
                <b>Eligible Members: {memberEligibleCount}</b>
              </div>
            </Colxx>
          )}

          {isBulkSource && isScheduled && bulkScheduleRecipientNotice && (
            <Colxx md="12" className="mb-2">
              <Alert color="warning" className="mb-0 py-2 px-3 text-left">
                <div className="d-flex align-items-start">
                  <i className="simple-icon-info mr-2 mt-1" aria-hidden="true" />
                  <span>{bulkScheduleRecipientNotice}</span>
                </div>
              </Alert>
            </Colxx>
          )}

          {showMarketingConsent && (
            <Colxx md="12" className="mb-2">
              <Label>Marketing Consent</Label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={MARKETING_CONSENT_OPTIONS}
                placeholder="All Eligible Members"
                value={marketingConsent}
                isClearable
                onChange={(val) => {
                  setMarketingConsent(val);

                  fetchEligibleCount(
                    val?.value || '',
                    selectedTag?.value || ''
                  );
                }}
              />
            </Colxx>
          )}
          {showTagList && (
            <Colxx md="12" className="mb-2">
              <Label>Tag</Label>

              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={tagList}
                value={selectedTag}
                placeholder="All Tags"
                isClearable
                onChange={(val) => {
                  setSelectedTag(val);

                  fetchEligibleCount(
                    marketingConsent?.value || '',
                    val?.value || ''
                  );
                }}
              />
            </Colxx>
          )}
          <Colxx md="12" className="mb-2">
            <Label>Template</Label>
            <Input
              type="select"
              name="Template"
              value={whatsAppData.templateId || ''}
              onChange={handleTemplate}
            >
              <option value="">Please Select</option>

              {Array.isArray(templateList) &&
                templateList
                  .filter(
                    (t) =>
                      Array.isArray(t.channel) &&
                      t.channel.some((c) => c && c.toLowerCase() === 'whatsapp')
                  )
                  .map((m) => (
                    <option key={m.templateId} value={m.templateId}>
                      {m.name}
                    </option>
                  ))}
            </Input>
          </Colxx>
          {whatsAppData?.templateId && whatsAppData?.templateId !== '' ? (
            <Fragment>
              {loading ? (
                <div className="text-center">
                  <Spinner color="primary" className="mb-1" />
                </div>
              ) : (
                <Fragment>
                  <Colxx md="12" className="mb-2">
                    <Label>Message</Label>
                    <Input
                      type="textarea"
                      value={whatsAppData?.text}
                      name="conditions"
                      disabled={true}
                    // onChange={handleChangeConditionsArr}
                    />
                  </Colxx>

                  {whatsAppData.placeholders?.map((ph, index) => (
                    <Colxx md="12" className="mb-2" key={index}>
                      <Label>Placeholder Information</Label>

                      <InputGroup>
                        <InputGroupAddon>
                          <InputGroupText style={{ width: '138px' }}>
                            {ph.key}
                          </InputGroupText>
                        </InputGroupAddon>

                        <Input
                          type="text"
                          value={
                            source === 'Bulk' || source === 'MembersBulk'
                              ? ph.label
                              : ph.value
                          }
                          disabled='true'
                          onChange={(e) =>
                            source !== 'Bulk' &&
                            source !== 'MembersBulk' &&
                            handlePlaceHolders(e.target.value, index)
                          }
                        />
                      </InputGroup>
                    </Colxx>
                  ))}

                  {showPhoneNumber && (
                    <Colxx md="12" className="mb-2">
                      <Label>Mobile Number</Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <Input
                            type="select"
                            name="countryCode"
                            value={whatsAppData.countryCode || '+64'}
                            onChange={(e) =>
                              setwhatsAppData({
                                ...whatsAppData,
                                countryCode: e.target.value,
                                to: `${e.target.value}${whatsAppData.rawNumber || ''
                                  }`,
                              })
                            }
                            style={{
                              width: '150px',
                              textAlign: 'center',
                              cursor: 'pointer',
                            }}
                            disabled
                          >
                            {countryCodes.map((c) => (
                              <option key={c.code} value={c.dial_code}>
                                {c.code} {c.dial_code} ({c.name})
                              </option>
                            ))}
                          </Input>
                        </InputGroupAddon>
                        {/* <Input
                          type="text"
                          placeholder="Enter phone number"
                          value={whatsAppData.rawNumber || ''}
                          disabled={isUSNumber}
                          style={{
                            backgroundColor: isUSNumber ? '#e9ecef' : 'white',
                            cursor: isUSNumber ? 'not-allowed' : 'text',
                          }}
                          onChange={(e) => {
                            if (isUSNumber) return;
                            const number = e.target.value.replace(/\D/g, '');
                            setwhatsAppData({
                              ...whatsAppData,
                              rawNumber: number,
                              to: `${whatsAppData.countryCode || '+64'}${number}`,
                            });
                          }}
                        /> */}
                        <Input
                          type="text"
                          value={whatsAppData.rawNumber || ''}
                          placeholder="Not available"
                          disabled
                        />
                      </InputGroup>
                      {!canSend && (
                        <div
                          style={{
                            color: '#dc3545',
                            fontSize: '12px',
                            marginTop: '5px',
                          }}
                        >
                          <b>No mobile number available for this contact.</b>
                        </div>
                      )}
                      {isUSNumber && (
                        <div
                          style={{
                            color: 'black',
                            fontSize: '12px',
                            marginTop: '5px',
                          }}
                        >
                          <b>
                            {' '}
                            WhatsApp business messages are not being sent to
                            U.S. numbers because Meta paused all marketing
                            messages to U.S. numbers on April 1, 2025.
                          </b>
                        </div>
                      )}
                    </Colxx>
                  )}
                </Fragment>
              )}
            </Fragment>
          ) : null}
          <Colxx md="12" className="text-center my-3">
            {statusMessage.text && !isScheduleStatusMessage && (
              <div className="mb-2 font-medium">
                <b>
                  {source === 'Bulk' || source === 'MembersBulk'
                    ? renderBulkStatus(statusMessage.text)
                    : renderManualStatus(statusMessage.text, statusMessage.type)}
                </b>
              </div>
            )}

            {!isUSNumber &&
              whatsAppData?.templateId &&
              whatsAppData?.templateId !== '' ? (
              <>
                <Separator className="mb-3" />

                {/* Schedule Message */}
                <div
                  className="d-flex align-items-center justify-content-center mb-3"
                  style={{
                    gap: '8px',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    id="scheduleWhatsAppMessage"
                    type="checkbox"
                    checked={isScheduled}
                    readOnly
                    onClick={handleScheduleToggle}
                    style={{
                      width: '16px',
                      height: '16px',
                      margin: 0,
                      cursor: 'pointer',
                      flexShrink: 0,
                    }}
                  />

                  <label
                    htmlFor="scheduleWhatsAppMessage"
                    style={{
                      marginLeft: '8px',
                      marginBottom: 0,
                      cursor: 'pointer',
                      userSelect: 'none',
                      fontSize: '14px',
                    }}
                  >
                    Schedule message
                  </label>
                </div>

                <Popover
                  placement="bottom"
                  isOpen={showDeleteConfirm}
                  target="scheduleWhatsAppMessage"
                  toggle={() => setShowDeleteConfirm(false)}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div style={{ maxWidth: '280px', textAlign: 'left' }}>
                      <div style={{ marginBottom: '8px' }}>
                        Unchecking will permanently delete this scheduled message. Are you sure?
                      </div>
                      <div className="d-flex justify-content-end" style={{ gap: '8px' }}>
                        <Button
                          color="secondary"
                          size="xs"
                          outline
                          onClick={() => setShowDeleteConfirm(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          color="danger"
                          size="xs"
                          onClick={handleConfirmScheduleDelete}
                          disabled={scheduleLoading}
                        >
                          Delete
                        </Button>
                      </div>
                    </div>
                  </PopoverBody>
                </Popover>

                {isScheduled && (
                  <div
                    className="text-left mb-3"
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: '12px',
                      background: '#fafafa',
                      display: isScheduled ? 'block' : 'none',
                    }}
                  >
                    <Label>Schedule Date & Time</Label>

                    {(() => {
                      const minMoment = getMinScheduleMoment();
                      const minDate = minMoment.format('YYYY-MM-DD');
                      const minHour = minMoment.format('HH');
                      const minMinute = minMoment.format('mm');
                      const parts = getScheduleParts();

                      const hourOptions =
                        (() => {
                          const filtered =
                            parts.date === minDate
                              ? HOUR_OPTIONS_24.filter((hour) => hour >= minHour)
                              : HOUR_OPTIONS_24;

                          if (filtered.includes(parts.hour)) {
                            return filtered;
                          }

                          return [parts.hour, ...filtered];
                        })();

                      const filteredMinuteOptions =
                        parts.date === minDate && parts.hour === minHour
                          ? FIVE_MINUTE_OPTIONS.filter((minute) => minute >= minMinute)
                          : FIVE_MINUTE_OPTIONS;

                      const minuteOptions =
                        filteredMinuteOptions.includes(parts.minute)
                          ? filteredMinuteOptions
                          : [parts.minute, ...filteredMinuteOptions];

                      return (
                        <div>
                          <Input
                            type="date"
                            value={parts.date}
                            min={minDate}
                            onChange={(e) =>
                              updateScheduledDateTimeFromParts({
                                ...parts,
                                date: e.target.value,
                              })
                            }
                            disabled={!isScheduled}
                            className="mb-2"
                          />

                          <InputGroup>
                            <Input
                              type="select"
                              value={parts.hour}
                              onChange={(e) =>
                                updateScheduledDateTimeFromParts({
                                  ...parts,
                                  hour: e.target.value,
                                })
                              }
                              disabled={!isScheduled}
                            >
                              {hourOptions.map((hour) => (
                                <option key={hour} value={hour}>
                                  {hour}
                                </option>
                              ))}
                            </Input>

                            <InputGroupAddon addonType="append">
                              <InputGroupText>:</InputGroupText>
                            </InputGroupAddon>

                            <Input
                              type="select"
                              value={parts.minute}
                              onChange={(e) =>
                                updateScheduledDateTimeFromParts({
                                  ...parts,
                                  minute: e.target.value,
                                })
                              }
                              disabled={!isScheduled}
                            >
                              {minuteOptions.map((minute) => (
                                <option key={minute} value={minute}>
                                  {minute}
                                </option>
                              ))}
                            </Input>
                          </InputGroup>
                        </div>
                      );
                    })()}

                    <div
                      className="mt-2"
                      style={{
                        fontSize: '12px',
                        color: '#6c757d',
                      }}
                    >
                      Location: <strong>{timeZone}</strong>
                    </div>
                  </div>
                )}

                {isScheduled && <Separator className="my-2" />}

                {isScheduled && scheduledProcessingStatus && (
                  <div className="mb-2 font-medium">
                    <b>
                      {renderManualStatus(
                        displayScheduledStatus,
                        displayScheduledStatus === 'Failed' ? 'error' : 'success'
                      )}
                    </b>
                  </div>
                )}

                {statusMessage.text && isScheduleStatusMessage && (
                  <div className="mb-2 font-medium">
                    <b>{renderManualStatus(statusMessage.text, statusMessage.type)}</b>
                  </div>
                )}

                <Button
                  color="primary"
                  size="xs"
                  onClick={sendWhatsAppMessage}
                  disabled={!canSend}
                >
                  Send
                </Button>

                <Button
                  color="primary"
                  size="xs"
                  className="ml-2"
                  onClick={scheduleWhatsAppMessage}
                  disabled={!isScheduled || !canSend || scheduleLoading}
                >
                  Schedule Message
                </Button>
              </>
            ) : null}
          </Colxx>
        </Row>
        {/* <div className="text-center my-3">
          {statusMessage.text && (
            <div className="mb-2 font-medium">
              <b>
                {source === 'Bulk' || source === 'MembersBulk'
                  ? renderBulkStatus(statusMessage.text)
                  : renderManualStatus(statusMessage.text)}
              </b>
            </div>
          )}

          {!isUSNumber && whatsAppData?.templateId && whatsAppData?.templateId !== '' ? (
            <>
              <Separator className="mb-3" />
              <Button
                color="primary"
                size="xs"
                onClick={sendWhatsAppMessage}
                disabled={!canSend}
              >
                Send
              </Button>
            </>
          ) : null}
        </div> */}
      </Card>
    </Fragment >
  );
};

export default WhatsApptab;
